module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "position"
  }, [_c('p', [_vm._v("JAVA研发工程师")])]), _vm._v(" "), _c('div', {
    staticClass: "statement"
  }, [_c('p', {
    staticClass: "request"
  }, [_vm._v("岗位职责：")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("(1)根据需求，独立完成进行高品质的Web研发工作；\n(2)确定产品的技术解决方案和开发时间评估；\n(3)负责开发功能模块的设计；\n(4)协同组内开发工作以及任务安排；\n(5)组织团队内交流和培训以及代码评审。")])]), _vm._v(" "), _c('div', {
    staticClass: "statement second"
  }, [_c('div', [_c('p', {
    staticClass: "request"
  }, [_vm._v("任职资格：")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("(1)2年及以上的互联网Java开发经验；\n(2)对Java面向对象软件结构有深入理解以及很强的应用能力，精通OO、AOP、设计模式，熟悉多线程并发，网络编程技术。熟练掌握Spring等主流的开发框架。\n(3)熟悉Java Web开发，熟悉HTML和JSP，对CSS、JavaScript有一定了解\n(4)熟练使用MySQL。\n(5)有分布式开发经验、熟练使用分布式服务框架，消息中间件和分布式存储系统等。\n(6)对技术有强烈的兴趣，喜欢钻研，具有良好的学习能力，沟通技能，团队合作能力；")])])]), _vm._v(" "), _c('div', {
    staticClass: "position"
  }, [_c('p', [_vm._v("IOS研发工程师")])]), _vm._v(" "), _c('div', {
    staticClass: "statement"
  }, [_c('p', {
    staticClass: "request"
  }, [_vm._v("岗位职责：")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("(1)熟悉 Interface Builder 和纯代码进行页面布局；\n(2)熟悉内存管理相关知识，编写安全代码；\n(3)熟悉 Debug 相关技能；\n(4)了解 Xcode 自带调试工具的使用，可以优化内存使用和定位内存泄漏；\n(5)了解包管理工具的使用；\n(6)了解开发者文档的结构，快速定位相关类/函数的使用和版本兼容性。")])]), _vm._v(" "), _c('div', {
    staticClass: "statement second"
  }, [_c('div', [_c('p', {
    staticClass: "request"
  }, [_vm._v("任职资格：")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("（1）两年以上客户端开发经验，精通iOS手机平台；\n（2）熟悉掌握swift编程语言，有相关开发经验不少于2年；\n（3）熟悉电商类app基本订单流程；\n（4）对新技术有浓厚的兴趣，不拘泥于落后过时的技术；\n（5）开发基础良好，理解设计模式，在项目或产品中有很好的设计实践；\n（6）有强烈的责任心和团队精神，善于沟通和合作；能独立完成设计和编码；\n（7）对iOS的UI控件有优化经验者优先，对数据搜索查找有优化经验者优先；有前端开发经验者优先。")])])]), _vm._v(" "), _c('div', {
    staticClass: "position"
  }, [_c('p', [_vm._v("PHP研发工程师")])]), _vm._v(" "), _c('div', {
    staticClass: "statement"
  }, [_c('p', {
    staticClass: "request"
  }, [_vm._v("岗位职责：")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("(1)根据需求，独立完成进行高品质的Web研发工作；\n(2)确定产品的技术解决方案和开发时间评估；\n(3)负责开发功能模块的设计；\n(4)协同组内开发工作以及任务安排；\n(5)组织团队内交流和培训以及代码评审。")])]), _vm._v(" "), _c('div', {
    staticClass: "statement second"
  }, [_c('div', [_c('p', {
    staticClass: "request"
  }, [_vm._v("任职资格：")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("(1)3年及以上的互联网行业开发经验；\n(2)精通高并发，高负载技术架构；\n(3)熟练运用Memcached、redis等noSql数据库；\n(4)熟练的进行数据库设计和优化，至少精通一种数据库应用，精通Mysql数据库应用者优先；\n(5)熟悉web架构，熟悉web应用的数据库设计；\n(6)精通linux及相关系统软件配置与优化；\n(7)具有良好的沟通能力和业务理解能力。")])])]), _vm._v(" "), _c('div', {
    staticClass: "position"
  }, [_c('p', [_vm._v("Web前端研发工程师")])]), _vm._v(" "), _c('div', {
    staticClass: "statement"
  }, [_c('p', {
    staticClass: "request"
  }, [_vm._v("岗位职责：")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("(1)具备3年以上工作经验\n(2)精通HTML5、JS、CSS和JQuery等常用WEB技术。\n(3)熟练掌握css中常见布局方式，以及CSS3动画技术 \n(4)熟悉AJAX、XML和JSON等技术。\n(5)熟悉Vue前端框架")])]), _vm._v(" "), _c('div', {
    staticClass: "statement second"
  }, [_c('div', [_c('p', {
    staticClass: "request"
  }, [_vm._v("任职资格：")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("(1)熟练掌握和了解各种Web前端相关语言，包括HTML/CSS/Javascript；\n(2)掌握HTML5、CSS3、EMCScript5标准，并利用这些技术制作动态页面效果；\n(3)熟练掌握Bootstrap、JQuery等前端框架和技术，熟练使用angular、react、backbone、canjs等前端JS框架的优先；\n(4)理解并能实际运用HTML语义化、前端组件化、模块化思想，对前端页面可用性、可访问性等相关知识有实际的了解和实践经验；\n(5)了解至少一门非Web前端语言（如Java、Shell）并有实践经验的优先；\n(6)个性乐观开朗，逻辑性强，善于和各种背景的人合作。")])])]), _vm._v(" "), _c('div', {
    staticClass: "position"
  }, [_c('p', [_vm._v("安卓研发工程师")])]), _vm._v(" "), _c('div', {
    staticClass: "statement"
  }, [_c('p', {
    staticClass: "request"
  }, [_vm._v("岗位职责：")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("(1)参与业务需求设计讨论，基于Android平台进行应用程序开发；\n(2)负责移动平台软件框架的研究，设计和实现、关键技术验证和选型等工作；\n(3)完成Android项目设计、编码、测试和优化；\n(4)编写相关的开发文档，如技术文档，设计文档，测试文档等。\n(5)开发针对不同的Android操作系统版本和屏幕尺寸的应用，并完成兼容性测试。")])]), _vm._v(" "), _c('div', {
    staticClass: "statement second"
  }, [_c('div', [_c('p', {
    staticClass: "request"
  }, [_vm._v("任职资格：")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("(1)Android平台手机终端软件开发精通Android开发平台及框架，三年以上实际开发经验；\n(2)熟悉HTML/WML/HTTP,具有良好的编程思想；\n(3)对Android框架有深入的了解；\n(4)对Android NDK有一定了解；\n(5)有Robotium（自动化测试框架）开发经验者优先。")])])]), _vm._v(" "), _c('div', {
    staticClass: "position"
  }, [_c('p', [_vm._v("测试开发工程师")])]), _vm._v(" "), _c('div', {
    staticClass: "statement"
  }, [_c('p', {
    staticClass: "request"
  }, [_vm._v("岗位职责：")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("(1)负责各端产品和业务的功能测试、REST API相关测试；\n(2)参与项目过程，制定测试计划和测试策略，对各个项目关键点进行把关，有效保证产品线质量；\n(3)能够设计测试用例，并且完成自动化测试脚本的开发；\n(4)参与构建互联网产品自动化测试、性能测试体系，管理测试环境；\n(5)参与线上系统监控研发、问题定位跟踪工具研发，保证线上问题高效发现和定位。")])]), _vm._v(" "), _c('div', {
    staticClass: "statement second"
  }, [_c('div', [_c('p', {
    staticClass: "request"
  }, [_vm._v("任职资格：")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("\n          (1)计算机相关专业本科及以上学历，3年及以上测试经验；\n          (2)具备一定的编程能力，熟练掌握Java/PHP中一种，熟练使用Python/Perl等脚本语言中的一种；\n          (3)熟悉Linux操作系统，熟练使用Shell；\n          (4)具有较强的业务分析能力，较好的沟通表达和综合协调能力；\n          (5)熟悉Nginx/Apache/Memcache/Redis等Web中间件，有hadoop/docker使用经验者优先；  \n          (6)熟练测试理论与方法，对互联网质量保证领域有强烈的兴趣； \n          (7)有性能、安全、白盒测试等专业测试领域经验者优先； \n          (8)熟悉Android自动化测试框架appium/uiautomator者优先；\n          (9)熟悉Jmeter/Loadrunner等压测工具者优先。\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "position"
  }, [_c('p', [_vm._v("技术总监")])]), _vm._v(" "), _c('div', {
    staticClass: "statement"
  }, [_c('p', {
    staticClass: "request"
  }, [_vm._v("岗位职责：")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("(1)根据公司经营战略，对技术部整体规划，全面计划、安排、管理、实施技术部工作。\n(2)组织制订并实施技术系统规章制度和实施细则。\n(3)把握公司技术发展方向，保持技术的先进性，负责解决技术难题、培养技术骨干。\n(4)根据公司整体发展方向，负责技术平台的开发、测试、维护。\n(5)负责开发电子商城系统，优化系统功能。\n(6)网站实施与协调，保证网站的顺利上线与部署。\n(7)组织技术、产品开发与创新。\n(8)负责平台产品的技术分析，准确捕抓技术价值，通过前沿调查，理解挖掘同类产品技术价值\n(9)领导安排的其他事宜。")])]), _vm._v(" "), _c('div', {
    staticClass: "statement second"
  }, [_c('div', [_c('p', {
    staticClass: "request"
  }, [_vm._v("任职资格：")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("\n          (1)本科以上学历.计算机等相关专业.\n          (2)熟悉互联网、电子商务、电子支付等相关行业,深厚的技术功底;能比较好地把握互联网、电子商务平台技术发展趋势、动态，对关键技术有比较深入的研究；\n          (3)三年以上电子商务网站技术总监或电子商务软件提供商技术总监以上工作经历，比较丰富的技术开发及项目管理经验；\n          (4)良好的技术管理团队管理能力。了解网络及系统管理及相关流程；\n          (5)拥有良好的市场策划管理能力和团队协调工作能力，有组织实施的执行能力，有整合资源、创新经营的思想；   \n          (6)擅长撰写各类策划方案，具有优秀的管理能力、逻辑分析能力，富有激情与创意； \n          (7)具有激励、沟通、协调、团队领导能力，责任心、事业心强，敢于承担责任。 ")])])]), _vm._v(" "), _c('div', {
    staticClass: "position"
  }, [_c('p', [_vm._v("网络管理员")])]), _vm._v(" "), _c('div', {
    staticClass: "statement"
  }, [_c('p', {
    staticClass: "request"
  }, [_vm._v("岗位职责：")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("(1)（1）负责公司内部局域网维护、监管，安全防火墙；\n(2)负责管理公司对外网络端口。\n(3)负责办公室网络的正常运行，解决日常工作中发生的问题。\n(4)保证系统在合理、安全环境下运行，按标准方法进行操作，是系统正常运行。\n(5)进行小型机、服务器、路由器等设备管理与维护，以及网络平台的运行监控和维护；\n(6)公司软硬件提供技术支持，公司电脑维护、检修。\n(7)领导安排的其他临时性工作；")])]), _vm._v(" "), _c('div', {
    staticClass: "statement second"
  }, [_c('div', [_c('p', {
    staticClass: "request"
  }, [_vm._v("任职资格：")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("\n          (1)1年以上网络管理工作经验，计算机专科以上学历。\n          (2)熟练掌握计算机软硬件方面知识，较强计算机系统及网络问题处理能力及软硬件终端处理能力；\n          (3)熟悉Windows XP/NT/2000相关网络的运行环境及PC机硬件维护；\n          (4)精通局域网的维护及网络安全，路由器，交换机、防火墙的网络设备的设置与管理；\n          (5)熟悉ADSL技术原理，熟练使用ADSL路由设备，精通ADSL共享技术；   \n          (6)熟悉WLAN技术，有WLAN配置、调试经验； \n          (7)具有独立分析和处理网络故障能力； \n          (8)学习能力强，较好的沟通和协作能力，极强的执行力和沟通能力，具备良好的服务意识；")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-64e26c58!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/join_us/HomeJoinResearch.vue
// module id = 154
// module chunks = 1